import { AlignCenter, AlignLeft, AlignRight, Apple, ArrowLeftRight, ArrowUpDown, Circle, FileSpreadsheet, Frame, GalleryVertical, GalleryVerticalEnd, Grid2x2Check, Hash, Languages, LanguagesIcon, LaptopMinimal, LayoutList, Minus, NotepadText, Palette, Plus, SmartphoneCharging, Square, Squircle, TabletSmartphone } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import ImagesUI from "../../../UI/ImagesUI";

import fallback_img from "../../../img/fallback_img.jpg"
import loading_img from "../../../img/loadingImg.jpg"
import Toggle from "../../../UI/Toggle";
import RangeSlider from "../../../UI/RangeSlider";
import RangeSliderBasic from "../../../UI/RangeSliderBasic";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import ColorPicker from "../../../UI/ColorPicker/Colorpicker";
import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";
const ListUISettings = ({ setItemArrCurrent,images,sendBackImagesArray,dynamicId,scrollItems, setScrollItems,columnsList, setColumnsList,fontFamily, setFontFamily
    ,iWidth, setiWidth,iHeight, setiHeight,
    titleFontSize, setTitleFontSize,subTitleFontSize, setSubTitleFontSize,titleFontColor, setTitleFontColor,subTitleFontColor, setSubTitleFontColor,
    titleFontWeight, setTitleFontWeight,subTitleFontWeight, setSubTitleFontWeight,
    borderRadius, setBorderRadius,marginLeft, setmarginLeft
    ,marginTop, setmarginTop,marginBottom, setmarginBottom,imarginLeft, setimarginLeft,imarginTop, setimarginTop,aspectRatio, setAspectRatio,
    showTitle, setShowTitle, showSubTitle, setShowSubTitle,textAlignment, setTextAlignment,textPosition, setTextPosition,
    applyOverlay,setApplyOverlay,overlayTitleFontColor, setOverlayTitleFontColor,overlayBG, setOverlayBG,

    

absoluteHorizontal,setAbsoluteHorizontal,absoluteVertical,setAbsoluteVertical,
absoluteHorizontalMargin,setAbsoluteHorizontalMargin,absoluteVerticalMargin,setAbsoluteVerticalMargin,
  
itemVisibility,setItemVisibility,
itemBackground, setItemBackground,setItemArr
}) => {
 const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }

];

      const dispatch = useDispatch();  
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
       
   const [itemImages, setItemImages] = useState(images);
  const [columns, setColumns] = useState(columnsList);
  const [activeSetting, setActiveSetting] = useState("settings");
const [scrollStatusLocal, setScrollStatusLocal] = useState(scrollItems);
const [aspectRatioLocal, setAspectRatioLocal] = useState(aspectRatio);
const [resolution, setPxPercent] = useState('px');
const [cornerType, setCornerType] = useState('');
const [textAlignmentLocal, setTextAlignmentLocal] = useState(textAlignment);
const [itemBackgroundLocal, setItemBackgroundLocal] = useState(itemBackground);
const [palletBG, setPalletBG] = useState(false);
const [palletBGTitle, setPalletBGTitle] = useState(false);
const [palletTitleOverlay, setPalletTitleOverlay] = useState(false);
const [palletOverlayBG, setPalletOverlayBG] = useState(false);
const [palletBGSubTitle, setPalletBGSubTitle] = useState(false);
const [absoluteVerticalLocal, setAbsoluteVerticalLocal] = useState(absoluteVertical);
const [loadAbsoluteSliderStatus, setLoadAbsoluteSliderStatus] = useState(true);
const [marginVerticalBoth, setMarginVerticalBoth] = useState(true);
 
 const [textPositionLocal ,setTextPositionLocal]  = useState(textPosition);
 const [fontFamilyPopup ,setFontFamilyPopup]  = useState(false);
 const [fontfamilyNameLocal ,setFontfamilyNameLocal]  = useState(fontFamily?.name);
 const [itemVisibilityLocal ,setItemVisibilityLocal]  = useState(itemVisibility);
                    
                    
                            const [activeColorPickerValueBG,setActiveColorPickerValueBG]=useState(itemBackgroundLocal)
                            const [activeColorPickerValueTitle,setActiveColorPickerValueTitle]=useState(titleFontColor)
                            const [activeColorPickerValueOverlayBG,setActiveColorPickerValueOverlayBG]=useState(overlayBG)
                             const [activeColorPickerValueOverlayTitle,setActiveColorPickerValueOverlayTitle]=useState(overlayTitleFontColor)
                            const [activeColorPickerValueSubTitle,setActiveColorPickerValueSubTitle]=useState(subTitleFontColor)
 const changeColumns = ( totalNumber) => { setColumnsList(totalNumber) ;updateColumnData(totalNumber) ; };
 
useEffect(()=>{ 
  setColumns(columnsList)
   setScrollStatusLocal(scrollItems)
   setAspectRatioLocal(aspectRatio)
},[])

const updateColumnData=(val)=>{
 setItemArr((prev) => {
  // these keys are used when duplicating items
    const updatedItems = prev.map(item => { if (item.myKey === dynamicId) {
       return {  ...item, columns:val };  }  return item;});
        
          setItemArrCurrent(updatedItems);return updatedItems;; });
      }
const updateScrollItems=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          scrollItems:val };
      }
     
      return item;
    });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateItemImages=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          images:val };
      }
     
      return item;
    });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
 const updateShowTitle=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          showTitle:val };
      }
     
      return item;
    });
   
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
} 

const updateTitleFontSize=(val)=>{

setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          titleFontSize:val };
      }
     
      return item;
    });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateTitleFontColor=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          titleFontColor:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateApplyOverlay=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          applyOverlay:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateOverlayBG=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          overlayBG:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}

const updateItemVisibility=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          itemVisibility:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}
const updateOverlayTitleFontColor=(val)=>{

   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          overlayTitleFontColor:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });


}

const updateSubTitleFontSize=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          subTitleFontSize:val };
      }
     
      return item;
    });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateSubTitleFontColor=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          subTitleFontColor:val };
      }
     
      return item;
    });
   
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}


const updateShowSubTitle=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          showSubTitle:val };
      }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}




const updateAspectRatio=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {
        return {
          ...item,
          aspectRatio:val };
      }
     
      return item;
    });
     
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateiMarginLeft=(val)=>{
   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {  ...item,   imarginLeft:val }; }
     
      return item;
    });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}



const updateiMarginTop=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return { ...item,   imarginTop:val }; }  return item;   });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateMarginBottom=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return { ...item,   marginBottom:val }; }  return item;   });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateMarginLeft=(val)=>{
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {   ...item,   marginLeft:val }; } return item; });
   
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateMarginTop=(val)=>{
   setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {  return { ...item,  marginTop:val };}  return item; });
  
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateBorderRadius=(val)=>{
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {  return {  ...item,  borderRadius:val };  } return item;});

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateFontFamily=(val)=>{
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {  return {   ...item,   fontFamily:val };}return item;  });
 
      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}

const updateTextAlignment=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) {  return { ...item, textAlignment:val };  } return item; });

      setItemArrCurrent(updatedItems);return updatedItems;;
  });
}



const updateItemBackground=(val)=>{
 setItemArr((prev) => {
  const updatedItems = prev.map(item => { 
     if (item.myKey === dynamicId) { return { ...item, itemBackground:val };}  return item; });   setItemArrCurrent(updatedItems);return updatedItems;;
  });
}
const updateiWidth=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {  ...item, iWidth:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}
const updateTextPosition=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {  ...item, textPosition:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}

const updateAbsoluteVerticalMargin=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {  ...item, absoluteVerticalMargin:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}
const updateAbsoluteVertical=(val)=>{
 setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {  ...item, absoluteVertical:val };} return item; });  setItemArrCurrent(updatedItems);return updatedItems;;  });
}


  return (<div  > 
     
       <div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px"}}>  
                    <div style={{background:activeSetting=="contents"?"rgba(144, 202, 249,1)":"#ffffff",width:"100px",color:activeSetting=="contents"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"16px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSetting("contents")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Contents</div>         
                 <div style={{background:activeSetting=="settings"?"rgba(144, 202, 249,1)":"#ffffff",width:"100px",color:activeSetting=="settings"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"16px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSetting("settings")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Settings</div>         
               </div>
 {/* <div style={{display:"flex",justifyContent:"left",color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
       Edit List 1</div>          */}
<div className="appSettingsScroller" >
   {activeSetting=="contents"?<div style={{background:"#ffffff",borderRadius:"15px"}}>  
                    <div style={{fontSize:"18px",fontWeight:"bold",padding:"10px",paddingTop:"15px",display:"flex",justifyContent:"left"}}>Items</div>         
              <div style={{fontSize:"12px",fontWeight:"500",padding:"10px",paddingTop:"0px",textAlign:"left"}}>
Add new items to your  List and order them. Set the style for all items in the Settings tab.</div>
           { itemImages?.length===0?  <div  style={{
            display:"flex",flexDirection: 'row',
    justifyContent: 'center',padding:"5px",
    marginBottom: 10}}>
           <img
        src={fallback_img }
        alt=""
       
        style={{
          borderRadius: "10px",
        
          width: "50%",
          marginTop: "10px",border:"3px solid rgba(144, 202, 249,1)",
        //   display: isLoaded && !hasError ? "block" : "none",
        }}
      /></div>:""}  
           { <ImagesUI images ={itemImages} sendBackArray={(val)=>{ setItemImages(val);updateItemImages(val) }}/> }
      
      
          </div> :""}  


                 {activeSetting=="settings"&&itemImages?.length?
                 <div style={{position:"relative"}} >
                  <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"0px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Set Columns & Background</div> 
                   <div style={{background:"#ffffff",display:"grid", gridTemplateColumns: "35% 45% 15%" ,borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                    <div style={{fontSize:"18px",fontWeight:"bold",padding:"8px",paddingTop:"15px"}}>Columns</div>         
               <div style={{margin: '5px' ,paddingLeft:"0px",width:"90px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setColumns(parseInt(columns)>1?parseInt(columns)-1:1)
    changeColumns(parseInt(columns)>1?parseInt(columns)-1:1);  
  }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
    <input onMouseEnter={handleMouseEnter} disabled
     onMouseLeave={handleMouseLeave}  value={parseInt(columns)} type="number"
          onChange={(e)=>{changeColumns(parseInt(e.target.value)<6?parseInt(e.target.value):1);setColumns(parseInt(e.target.value)<6?parseInt(e.target.value):1);}}
          style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",
            padding:"0px",marginLeft:"5px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setColumns(parseInt(columns)<6?parseInt(columns)+1:6)
        changeColumns(parseInt(columns)<6?parseInt(columns)+1:6); 
      
      }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
        
        
        
        </div> 
        
        <div style={{paddingTop:"10px"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <Palette onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={palletBG?"yes":""}
                   className="input-textbox"  value={palletBG}  name="palletBG1"  
                   onChange={e=>{setPalletBG(e.target.checked);setPalletTitleOverlay(false);setPalletOverlayBG(false);setPalletBGTitle(false);;setPalletBGSubTitle(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
{palletBG?
 <div style={{position:"absolute",right:"0px",top:"110px",zIndex:"9999999"}}><ColorPickerDynamic activeColorPickerValue={activeColorPickerValueBG} setActiveColorPickerValue={(color)=>{
setItemBackground(color);updateItemBackground(color);setActiveColorPickerValueBG(color)}} colorPickerOptionArray={[]}   palletTitle={"Set Item Background Color"} /> 
</div>:""}</div>
        
        </div>
         <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Item Display Settings</div>         
         
                 <div style={{borderRadius:"15px",paddingBottom:"10px",marginTop:"5px",padding:"0px",}}>
                      

             <div className="" style={{borderRadius:"0px",margin:"5px",paddingBottom:"0px",
              height:"80px"}}> 
       <div >  
           <div style={{}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div class=" gridFiftyFixed">
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             <Grid2x2Check onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     <div style={{position:"relative"}}>
                                                Grid
                                              </div>  </div>  
                              <input type="radio" title="Set As Years"   checked={scrollStatusLocal=="Grid"?"yes":""}
                   className="input-textbox"  value={"Grid"}  name="scrollStatus1"  
                   onClick={e=>{setScrollStatusLocal("Grid");setScrollItems("Grid");updateScrollItems("Grid");}}/>
                        <span class={"boxCardBorder"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <ArrowLeftRight onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     
                                                                       <div style={{position:"relative"}}>Scroll</div>
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={scrollStatusLocal=="Scroll"?"yes":""}
                   className="input-textbox"  value="Scroll"  name="scrollStatus1"  
                   onChange={e=>{setScrollStatusLocal("Scroll");setScrollItems("Scroll");updateScrollItems("Scroll")}}/>
                        <span class={"boxCardBorder"}></span> </label> 
                        </div>  </div></div> </div>
                        
                                                    </div>

                 </div>
                   <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Image Settings</div>  
<div style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"10px",}}>
       
               
             <div className="" style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginBottom:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        
                      
            
                        <div style={{display:"flex",justifyContent:"space-around"}}><h4>{"Radius "} </h4>
                        <div style={{display:"flex",justifyContent:"space-around"}}>
            <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ setCornerType("");
              setBorderRadius({value:val,resolution:resolution});
              updateBorderRadius({value:val,resolution:resolution})}} 
               sliderVal={borderRadius?.value} />
              <div style={{height:"50px" ,width:"90px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  
                         
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} >
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                          %
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="%"?"yes":""}
                   className="input-textbox"  value="%"  name="resolution1"  
                   onChange={e=>{setPxPercent("%")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            px                        
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="px"?"yes":""}
                   className="input-textbox"  value="px"  name="resolution1"  
                   onChange={e=>{setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div></div></div>
               </div> 
               <div style={{height:"60px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{"Corner Type  "} </h4>   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                           <Square color={"#333"} size={30}/>
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={cornerType=="square"?"yes":""}
                   className="input-textbox"  value={"square"}  name="cornerType1"  
                   onClick={e=>{setCornerType("square");
                    setBorderRadius({value:0,resolution:"px"});
                     updateBorderRadius({value:0,resolution:"px"})
                   ;setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                            <Squircle color={"#333"} size={30}/>                       
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="squircle"?"yes":""}
                   className="input-textbox"  value="squircle"  name="cornerType1"  
                   onChange={e=>{setCornerType("squircle");
                   setBorderRadius({value:10,resolution:"px"});
                   updateBorderRadius({value:10,resolution:"px"});
                   setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                               <Circle color={"#333"} size={30}/>
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="circle"?"yes":""}
                   className="input-textbox"  value="circle"  name="cornerType1"  
                   onChange={e=>{setCornerType("circle");
                    setBorderRadius({value:50,resolution:aspectRatioLocal=="1/1"?"%":"px"});
                   updateBorderRadius({value:50,resolution:aspectRatioLocal=="1/1"?"%":"px"});
                    
                   aspectRatioLocal=="1/1"?setPxPercent("%"):setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                         
                        </div>  </div></div> 

                        <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{"Crop Ratio"} </h4>
           <div style={{height:"110px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             2/1
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={aspectRatioLocal=="2/1"?"yes":""}
                   className="input-textbox"  value={"2/1"}  name="aspectRatio1"  
                   onClick={e=>{setAspectRatio("2/1");updateAspectRatio("2/1");
                   setAspectRatioLocal("2/1");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                            1/1                        
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={aspectRatioLocal=="1/1"?"yes":""}
                   className="input-textbox"  value="1/1"  name="aspectRatio1"  
                   onChange={e=>{setAspectRatio("1/1");updateAspectRatio("1/1");setAspectRatioLocal("1/1")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            3/4
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={aspectRatioLocal=="3/4"?"yes":""}
                   className="input-textbox"  value="3/4"  name="aspectRatio1"  
                   onChange={e=>{setAspectRatio("3/4");updateAspectRatio("3/4");setAspectRatioLocal("3/4")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                             4/3                        
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={aspectRatioLocal=="4/3"?"yes":""}
                   className="input-textbox"  value="4/3"  name="aspectRatio1"  
                   onChange={e=>{setAspectRatio("4/3");updateAspectRatio("4/3");setAspectRatioLocal("4/3")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div>
                         <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             4/1
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={aspectRatioLocal=="4/1"?"yes":""}
                   className="input-textbox"  value={"4/1"}  name="aspectRatio1"  
                   onClick={e=>{setAspectRatio("4/1");updateAspectRatio("4/1");
                   setAspectRatioLocal("4/1");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            9/16
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={aspectRatioLocal=="9/16"?"yes":""}
                   className="input-textbox"  value="9/16"  name="aspectRatio1"  
                   onChange={e=>{setAspectRatio("9/16");updateAspectRatio("9/16");setAspectRatioLocal("9/16")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                             16/9                      
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={aspectRatioLocal=="16/9"?"yes":""}
                   className="input-textbox"  value="16/9"  name="aspectRatio1"  
                   onChange={e=>{setAspectRatio("16/9");updateAspectRatio("16/9");setAspectRatioLocal("16/9")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div>
                        </div> </div>
                                                    </div></div>
                  {

  // apply Overlay
}
                          <div  style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"5px",height:"60px"}}> 
  
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{" Image Overlay"} </h4></div>
            <Toggle state={applyOverlay} toggleState={(state)=>{setApplyOverlay(state); updateApplyOverlay(state); ;}} />
    {applyOverlay?                                    
 <div style={{paddingTop:"10px",position:"relative"}}>
  
   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <Palette onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={palletOverlayBG?"yes":""}
                   className="input-textbox"  value={palletOverlayBG}  name="palletOverlayBG1"  
                   onChange={e=>{setPalletOverlayBG(e.target.checked);setPalletBG(false);setPalletBGTitle(false);setPalletBGSubTitle(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
{palletOverlayBG?
 <div style={{position:"absolute",right:"-15px",bottom:"70px",zIndex:"9999999"}}><ColorPickerDynamic activeColorPickerValue={activeColorPickerValueOverlayBG} setActiveColorPickerValue={(color)=>{
setOverlayBG(color);updateOverlayBG(color);setActiveColorPickerValueOverlayBG(color)}} palletTitle={"Set Overlay Background"} colorPickerOptionArray={[]} /> 
</div>:""}</div>:""}   </div> </div>
                  
           
             
        <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Text Settings</div> 
        

                   <div  style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"5px",}}> 
   <div  style={{border:"0px solid rgba(144, 202, 249,1)",width:"300px",display:"flex",gap:"0px",justifyContent:"space-around",marginTop:"5px"}}>
                 <div style={{border:"0px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"5px",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}><div style={{textAlign:"center"}}><h4>{"Title "} </h4></div>
            <Toggle state={showTitle} toggleState={(state)=>{setShowTitle(state); updateShowTitle(state); ;}} />
               </div>
                 <div style={{border:"0px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"5px",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}><div style={{textAlign:"center"}}><h4>{"Subtitle "} </h4></div>
            <Toggle state={showSubTitle} toggleState={(state)=>{setShowSubTitle(state);updateShowSubTitle(state); ;}} />
               </div>  </div>    </div>
                              
                           {showTitle||showSubTitle? <div> 
                 

   
                   
                 <div style={{background:"#ffffff",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",}}>
                       <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"10px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Text Position</div> 

             <div className="" style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"0px",paddingBottom:"0px",marginTop:"10px",
              height:"80px"}}> 
       <div >  
           <div style={{}}> 
            <div class=""style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div style={{display:"flex",justifyContent:"space-between"}}>
                                              <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",}} >
                                              <div style={{display:"flex",justifyContent:"center"}}>
                                             <FileSpreadsheet onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                    <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>On Image</div>
                                                                     </div>  
                                <input type="radio" title="Set As Years"   checked={textPosition=="onImage"?"yes":""}
                   className="input-textbox"  value={"onImage"}  name="textPosition1"  
                   onClick={e=>{setTextPositionLocal("onImage");setTextPosition("onImage");updateTextPosition("onImage");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column"}} >
                                              
                                             <div style={{display:"flex",justifyContent:"center"}}>
                                             <LaptopMinimal onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                   <div style={{position:"relative",fontSize:"14px"}}> Below  Image</div>
                                                                    </div>  
                              <input type="radio" title="Set As Years"   checked={textPosition=="below"?"yes":""}
                   className="input-textbox"  value={"below"}  name="textPosition1"  
                   onClick={e=>{setTextPositionLocal("below");setTextPosition("below");updateTextPosition("below");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                            <div style={{display:"flex",flexDirection:"column"}} >
                                            
                                           <div style={{display:"flex",justifyContent:"center"}}>
                                             <GalleryVerticalEnd onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>                     
                                                                           <div style={{position:"relative",fontSize:"14px"}}>Above Image</div>
                                             </div> 
                                <input type="radio" title="Set As Years"   checked={textPosition=="above"?"yes":""}
                   className="input-textbox"  value={"above"}  name="textPosition1"  
                   onClick={e=>{setTextPositionLocal("above");setTextPosition("above");updateTextPosition("above");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div></div> </div>
                        
                                                    </div>

                 </div>
</div>
:""}       
    {showTitle||showSubTitle?
   <div  style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"5px",height:"60px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{"Text Direction "} </h4>   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"center",alignItems:"center"}} >
                                              
                                           <AlignLeft color={"#333"} size={24}/>
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={textAlignmentLocal=="left"?"yes":""}
                   className="input-textbox"  value={"left"}  name="textAlignment1"  
                   onClick={e=>{setTextAlignment("left");updateTextAlignment("left");setTextAlignmentLocal("left");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"center",alignItems:"center"}} >
                                            
                                            <AlignCenter color={"#333"} size={24}/>                       
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={textAlignmentLocal=="center"?"yes":""}
                   className="input-textbox"  value="center"  name="textAlignment1"  
                   onChange={e=>{setTextAlignment("center");updateTextAlignment("center");setTextAlignmentLocal("center")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"center",alignItems:"center"}} >
                                               <AlignRight color={"#333"} size={24}/>
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={textAlignmentLocal=="right"?"yes":""}
                   className="input-textbox"  value="right"  name="textAlignment1"  
                   onChange={e=>{setTextAlignment("right");updateTextAlignment("right");setTextAlignmentLocal("right")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                         
                        </div>  </div></div> :""}
      
                {textPosition=="onImage"?
                
                 <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",}}>



                   <div  style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"15px",padding:"0px",margin:"0px",marginTop:"5px"}}>
       

               { <div style={{background:"#ffffff"}} >
                

               {showTitle||showSubTitle?<div>
                 <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                Text  Font Size </div> 
                 <div  style={{border:"0px solid rgba(144, 202, 249,1)",display:"flex",gap:"4px",padding:"10px",justifyContent:"space-around",marginTop:"25px"}}>
                
          {showTitle?  <RangeSliderBasic   rangeIntervalType="fontsize" rangeStart={8} rangeEnd={38} pxPerType={"px"}  setSliderVal={(val)=>{ setTitleFontSize(val);updateTitleFontSize(val)}}  sliderVal={titleFontSize} />
        :""} 
        {showSubTitle?<RangeSliderBasic rangeIntervalType="fontsize" rangeStart={8} rangeEnd={38}  pxPerType={"px"}  setSliderVal={(val)=>{ setSubTitleFontSize(val); updateSubTitleFontSize(val)}}  sliderVal={subTitleFontSize} />
             :""}                                                           
 <div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <Palette onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={palletTitleOverlay?"yes":""}
                   className="input-textbox"  value={palletTitleOverlay}  name="palletTitleOverlay1"  
                   onChange={e=>{setPalletTitleOverlay(e.target.checked);setPalletOverlayBG(false);setPalletBG(false);setPalletBGTitle(false);setPalletBGSubTitle(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
{palletTitleOverlay?
 <div style={{position:"absolute",right:"-15px",bottom:"70px",zIndex:"9999999"}}><ColorPickerDynamic activeColorPickerValue={activeColorPickerValueOverlayTitle} setActiveColorPickerValue={(color)=>{
setOverlayTitleFontColor(color);updateOverlayTitleFontColor(color);setActiveColorPickerValueOverlayTitle(color)}} palletTitle={"Set Overlay Title Color"} colorPickerOptionArray={[]} /> 
</div>:""}</div>
</div>

 <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
             Overlay Text </div>
                  
        <div  style={{border:"0px solid rgba(144, 202, 249,1)",display:"flex",gap:"4px",justifyContent:"space-around",marginTop:"25px",height:"80px"}}>
                   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px"}}>
                                             <div style={{display:"flex",justifyContent:"center",alignItems:"center",fontSize:"18px"}} >
                                              Top
                                                                      </div>  
                              <input type="radio" title=""   checked={absoluteVerticalLocal=="top"?"yes":""}
                   className="input-textbox"  value={"top"}  name="absoluteVertical1"  
                   onClick={e=>{setAbsoluteVertical("top");updateAbsoluteVertical("top");setAbsoluteVerticalLocal("top");
                        setAbsoluteVerticalMargin(1);updateAbsoluteVerticalMargin(1)
                        setLoadAbsoluteSliderStatus(false);setTimeout(()=>setLoadAbsoluteSliderStatus(true),0)
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                             <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px"}}>
                                             <div style={{display:"flex",justifyContent:"center",alignItems:"center",fontSize:"18px"}} >
                                              Bottom
                                                                      </div>  
                              <input type="radio" title=""   checked={absoluteVerticalLocal=="bottom"?"yes":""}
                   className="input-textbox"  value={"bottom"}  name="absoluteVertical1"  
                   onClick={e=>{setAbsoluteVertical("bottom");updateAbsoluteVertical("bottom");setAbsoluteVerticalLocal("bottom");
                     setAbsoluteVerticalMargin(1);updateAbsoluteVerticalMargin(1);
                     setLoadAbsoluteSliderStatus(false);setTimeout(()=>setLoadAbsoluteSliderStatus(true),0)
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                {loadAbsoluteSliderStatus?<RangeSliderBasic  rangeIntervalType="textMargin" rangeStart={0} rangeEnd={50}  pxPerType={"%"} setSliderVal={(val)=>{ setAbsoluteVerticalMargin(val);updateAbsoluteVerticalMargin(val)}}  sliderVal={absoluteVerticalMargin} />:""
                 }
            </div>


</div>:""}
  

  
               
                  


            </div>}
               </div>
               </div> : <div>
                
                
                 <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",}}>
                      <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                Text  Font Size </div> 
       <div  style={{padding:"10px"}}>
         
               {showTitle? <div style={{background:"#ffffff",}} >
                <div  style={{border:"0px solid rgba(144, 202, 249,1)",display:"flex",justifyContent:"space-around",marginTop:"15px"}}>
                
                <h5 style={{width:"96px"}}>{"Title Font Size"} </h5>
            <RangeSliderBasic  rangeIntervalType="fontsize" rangeStart={8} rangeEnd={38}   pxPerType={"px"}   setSliderVal={(val)=>{ setTitleFontSize(val);updateTitleFontSize(val)}}  sliderVal={titleFontSize} />
                                
 <div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <Palette onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={palletBGTitle?"yes":""}
                   className="input-textbox"  value={palletBGTitle}  name="palletBG1"  
                   onChange={e=>{setPalletBGTitle(e.target.checked);setPalletTitleOverlay(false);setPalletOverlayBG(false);setPalletBG(false);setPalletBGSubTitle(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
{palletBGTitle?
 <div style={{position:"absolute",right:"-15px",bottom:"70px",zIndex:"9999999"}}><ColorPickerDynamic activeColorPickerValue={activeColorPickerValueTitle} setActiveColorPickerValue={(color)=>{
setTitleFontColor(color);updateTitleFontColor(color);setActiveColorPickerValueTitle(color)}} palletTitle={"Set Title Color"} colorPickerOptionArray={[]} /> 
</div>:""}</div>
</div>


            </div>:""}
               
                {showSubTitle?<div style={{background:"#ffffff",}} ><div  style={{background:"#ffffff",border:"0px solid rgba(144, 202, 249,1)",display:"flex",justifyContent:"space-around",marginTop:"15px"}}>
                  <h5 style={{width:"96px"}}>{" Subtitle Font Size"} </h5>
            <RangeSliderBasic rangeIntervalType="fontsize" rangeStart={8} rangeEnd={38} pxPerType={"px"}   setSliderVal={(val)=>{ setSubTitleFontSize(val); updateSubTitleFontSize(val)}}  sliderVal={subTitleFontSize} />
                                                 
 <div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <Palette onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={palletBGSubTitle?"yes":""}
                   className="input-textbox"  value={palletBG}  name="palletBG1"  
                   onChange={e=>{setPalletBGSubTitle(e.target.checked);setPalletTitleOverlay(false);setPalletOverlayBG(false);;setPalletBG(false);setPalletBGTitle(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
{palletBGSubTitle?
 <div style={{position:"absolute",right:"-15px",bottom:"70px",zIndex:"9999999"}}><ColorPickerDynamic activeColorPickerValue={activeColorPickerValueSubTitle} setActiveColorPickerValue={(color)=>{
setSubTitleFontColor(color);updateSubTitleFontColor(color);setActiveColorPickerValueSubTitle(color)}} colorPickerOptionArray={[]}  palletTitle={"Set Subtitle Color"} /> 
</div>:""}</div>
               </div>
               </div>:""}
              
               </div>
               

  </div></div>
 }
        
               
 
             
                   <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",}}>
                      <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                Set Margin </div> 
       <div  style={{padding:"10px"}}>
                  <div  style={{border:"0px solid rgba(144, 202, 249,1)",display:"flex",gap:"4px",padding:"0px",justifyContent:"space-around",marginTop:"25px"}}>
               {marginVerticalBoth? <div style={{display:"flex",justifyContent:"left"}}> <div style={{marginTop:"20px",width:"70px"}}>Margin :</div> <RangeSliderBasic   rangeIntervalType="itemMargin" rangeStart={1} rangeEnd={100} pxPerType={"px"}  setSliderVal={(val)=>{ setmarginTop(val);updateMarginTop(val);setmarginBottom(val);updateMarginBottom(val)}}  sliderVal={marginTop} />
             </div> :<div>
              <div style={{display:"flex",justifyContent:"left"}}> <div style={{marginTop:"20px",width:"100px"}}>Margin Top :</div> <RangeSliderBasic   rangeIntervalType="itemMargin" rangeStart={1} rangeEnd={100} pxPerType={"px"}  setSliderVal={(val)=>{ setmarginTop(val);updateMarginTop(val);}}  sliderVal={marginTop} />
           </div><div style={{display:"flex",justifyContent:"left"}}>  <div style={{marginTop:"20px",width:"100px"}}>Margin Bottom :</div><RangeSliderBasic   rangeIntervalType="itemMargin" rangeStart={1} rangeEnd={100} pxPerType={"px"}  setSliderVal={(val)=>{ setmarginBottom(val);updateMarginBottom(val)}}  sliderVal={marginBottom} />
         </div></div> }  <div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             {marginVerticalBoth?<Hash onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                       :<Frame onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>}
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={marginVerticalBoth?"yes":""}
                   className="input-textbox"  value={marginVerticalBoth}  name="palletTitleOverlay1"  
                   onChange={e=>{setMarginVerticalBoth(e.target.checked);}}/>
                        <span class={"boxCardBorder-two"}></span> </label> </div> </div> </div> </div>
            

        
        

 
                   <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-around",}}>
                <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left",width:"200px"}}>
                  Font: <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:fontFamily?.fontFamily}}>{fontfamilyNameLocal}</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <Languages onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                     
                                             </div> 
                              <input type="checkbox" title=""   checked={fontFamilyPopup?"yes":""}
                   className="input-textbox"  value={palletBG}  name="fintFamily1"  
                   onChange={e=>{setFontFamilyPopup(e.target.checked);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
{fontFamilyPopup?
  <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
 <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                  Font: <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:fontFamily?.fontFamily}}>{fontfamilyNameLocal}</div>  </div>
                 <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                  
                    {fonts?.map((item,index) => (
                   <>  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                             <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                     <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                             </div> 
                              <input type="radio" title=""   checked={fontfamilyNameLocal==item?.name?"yes":""}
                   className="input-textbox"  value={item?.name}  name="FontFamily1"  
                   onChange={e=>{setFontFamily(item);updateFontFamily(item);setFontfamilyNameLocal(item?.name)}}/>
                        <span class={"boxCardBorder-two"}></span> </label> </>
                    ))}
                    </div></div>:""}</div></div>
 
                 <div style={{background:"#ffffff",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",}}>
                       <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"10px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Item Visibility</div> 

             <div className="" style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"0px",paddingBottom:"0px",marginTop:"10px",
              height:"80px"}}> 
       <div >  
           <div style={{}}> 
            <div class=""style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div style={{display:"flex",justifyContent:"space-between"}}>
                                              <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                              <div style={{display:"flex",justifyContent:"center"}}>
                                             <TabletSmartphone onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                    <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Both</div>
                                                                     </div>  
                                <input type="radio" title="Set As Years"   checked={itemVisibilityLocal=="Both"?"yes":""}
                   className="input-textbox"  value={"Both"}  name="itemVisibility1"  
                   onClick={e=>{setItemVisibility("Both");setItemVisibilityLocal("Both");updateItemVisibility("Both");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>    <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                              <div style={{display:"flex",justifyContent:"center"}}>
                                             <SmartphoneCharging onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                    <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Android</div>
                                                                     </div>  
                                <input type="radio" title="Set As Years"   checked={itemVisibilityLocal=="Android"?"yes":""}
                   className="input-textbox"  value={"Android"}  name="itemVisibility1"  
                   onClick={e=>{setItemVisibility("Android");setItemVisibilityLocal("Android");updateItemVisibility("Android");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                              
                                             <div style={{display:"flex",justifyContent:"center"}}>
                                             <Apple onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                   <div style={{position:"relative",fontSize:"14px"}}> iOS</div>
                                                                    </div>  
                              <input type="radio" title="Set As Years"   checked={itemVisibilityLocal=="iOS"?"yes":""}
                   className="input-textbox"  value={"iOS"}  name="itemVisibility1"  
                   onClick={e=>{setItemVisibility("iOS");setItemVisibilityLocal("iOS");updateItemVisibility("iOS");;}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        
                        </div>  </div></div> </div>
                        
                                                    </div>

                 </div>
                

                </div> : ""}
          {!images?.length&& <div
                  className="drop-zone posRelative "
                 
                  style={{
                    height:'100px',position:'relative',left:"5px",right:"5px",
                    backgroundColor:  'rgba(144, 202, 249,0.2) ' , // Change color on hover
                    border:  '0px dashed rgba(144, 202, 249,1) ' , // Change color on hover
                    transition: 'background-color  0.3s ease',width:"95%",
                    borderRadius: '10px',marginTop:"20px"
                   
                  ,marginBottom:"20px"
                   
                  ,display:"flex",justifyContent:"center",
                   visibility:"visible",fontSize:"18px",fontWeight:"bold"
                  }}
                ><div style={{paddingTop:"40px",}}>Select Any Element </div><div className="showPlusElement" ></div>
           </div>} 
           
          {!itemImages?.length&& <div
                  className="drop-zone posRelative "
                 
                  style={{
                    height:'100px',position:'relative',left:"5px",right:"5px",
                    backgroundColor:  'rgba(144, 202, 249,0.2) ' , // Change color on hover
                    border:  '0px dashed rgba(144, 202, 249,1) ' , // Change color on hover
                    transition: 'background-color  0.3s ease',width:"95%",
                    borderRadius: '10px',marginTop:"20px"
                   
                  ,marginBottom:"20px"
                   
                  ,display:"flex",justifyContent:"center",
                   visibility:"visible",fontSize:"18px",fontWeight:"bold"
                  }}
                ><div style={{paddingTop:"40px",}}>Content Not Found </div><div className="showPlusElement" ></div>
           </div>}  
        </div>         
                            
                             </div> );
};


export default ListUISettings;
